import { AzureKeyVault } from '../model/linkedservice/key-vault';
import { Owned } from '../model/base/named';
import { Metamodel } from '../model/base/model';
import { IAttribute, IModel } from '../model/base/annotation';

@Metamodel.model({})
export class KeyValuePairWithAkv extends Owned {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;

    public key: string;

    @Metamodel.attribute({
        templatable: true,
        accepts: ['String'],
        association: 'VALUE'
    })
    public value: string | null | AzureKeyVault;
}

export interface IKeyValuePair<K,V> {
    key: K;
    value: V;
}
